/**
 * 9 Constitution Types Configuration
 * Based on CCMQ - Prof. Wang Qi (王琦) methodology
 */

export const CONSTITUTION_TYPES = {
    pinghe: {
        id: 'pinghe',
        code: 'A',
        name: 'Bình hòa chất',
        name_cn: '平和质',
        name_en: 'Balanced Constitution',
        icon: '⚖️',
        color: '#10B981',
        prevalence: '32.75%',
        characteristics: [
            'Thể hình cân đối, khỏe mạnh',
            'Da dẻ hồng hào, tươi nhuận',
            'Tinh lực dồi dào, không dễ mệt',
            'Giấc ngủ sâu, ngon',
            'Tính cách hòa nhã, lạc quan'
        ],
        tongueFeatures: 'Lưỡi hồng nhạt, rêu mỏng trắng',
        pulseFeatures: 'Mạch hòa hoãn, có lực',
        diseaseTendencies: ['Ít mắc bệnh', 'Hồi phục nhanh'],
        dietaryAdvice: {
            recommended: ['Gạo tẻ', 'Đậu đũa', 'Thịt gà', 'Hạt óc chó'],
            avoid: ['Không thiên lệch một vị', 'Không ăn quá mặn/ngọt/cay']
        },
        lifestyleAdvice: ['Duy trì lối sống cân bằng', 'Tập thể dục đều đặn']
    },

    qixu: {
        id: 'qixu',
        code: 'B',
        name: 'Khí hư chất',
        name_cn: '气虚质',
        name_en: 'Qi Deficiency Constitution',
        icon: '🔋',
        color: '#F59E0B',
        prevalence: '12.71%',
        characteristics: [
            'Hay mệt mỏi, hụt hơi',
            'Tim đập nhanh, hồi hộp',
            'Chóng mặt khi đứng dậy',
            'Dễ ra mồ hôi khi vận động nhẹ',
            'Giọng nói nhỏ, yếu ớt'
        ],
        tongueFeatures: 'Lưỡi nhạt màu, có dấu răng ở rìa',
        pulseFeatures: 'Mạch hư nhược, vô lực',
        diseaseTendencies: ['Cảm cúm thường xuyên', 'Sa nội tạng', 'Mệt mỏi mạn tính'],
        dietaryAdvice: {
            recommended: ['Hoàng kỳ', 'Đảng sâm', 'Đại táo', 'Thịt gà', 'Gạo nếp'],
            avoid: ['Củ cải sống', 'Đồ lạnh', 'Trà đậm', 'Rượu bia']
        },
        lifestyleAdvice: ['Nghỉ ngơi đầy đủ', 'Tránh lao động quá sức', 'Tập nhẹ nhàng']
    },

    yangxu: {
        id: 'yangxu',
        code: 'C',
        name: 'Dương hư chất',
        name_cn: '阳虚质',
        name_en: 'Yang Deficiency Constitution',
        icon: '❄️',
        color: '#3B82F6',
        prevalence: '7.9%',
        characteristics: [
            'Sợ lạnh, mặc nhiều áo',
            'Tay chân lạnh, đặc biệt mùa đông',
            'Bụng, lưng, đầu gối hay bị lạnh',
            'Tiêu chảy khi ăn đồ lạnh',
            'Tiểu nhiều lần, nước tiểu trong'
        ],
        tongueFeatures: 'Lưỡi nhạt, bệu, rêu trắng ướt',
        pulseFeatures: 'Mạch trầm trì, vô lực',
        diseaseTendencies: ['Phù thũng', 'Tiêu chảy mạn tính', 'Loãng xương'],
        dietaryAdvice: {
            recommended: ['Thịt cừu', 'Gừng khô', 'Quế', 'Long nhãn', 'Hạt óc chó'],
            avoid: ['Thịt vịt', 'Dưa hấu', 'Đồ uống lạnh', 'Cua, ốc']
        },
        lifestyleAdvice: ['Giữ ấm cơ thể', 'Vận động để sinh dương khí', 'Tránh môi trường lạnh']
    },

    yinxu: {
        id: 'yinxu',
        code: 'D',
        name: 'Âm hư chất',
        name_cn: '阴虚质',
        name_en: 'Yin Deficiency Constitution',
        icon: '🔥',
        color: '#EF4444',
        prevalence: '8.89%',
        characteristics: [
            'Lòng bàn tay, bàn chân nóng',
            'Miệng khô, hay khát nước',
            'Đổ mồ hôi trộm (đêm)',
            'Táo bón, phân khô',
            'Hay cáu gắt, nóng tính'
        ],
        tongueFeatures: 'Lưỡi đỏ, rêu ít hoặc không rêu, khô',
        pulseFeatures: 'Mạch tế sác (nhỏ, nhanh)',
        diseaseTendencies: ['Mất ngủ', 'Tiểu đường', 'Tăng huyết áp', 'Viêm họng mạn'],
        dietaryAdvice: {
            recommended: ['Kỷ tử', 'A giao', 'Sữa', 'Vịt', 'Mật ong', 'Bách hợp'],
            avoid: ['Gừng, tỏi', 'Ớt, tiêu', 'Thịt cừu', 'Rượu', 'Đồ chiên rán']
        },
        lifestyleAdvice: ['Tránh nơi nóng bức', 'Giữ tâm trạng bình tĩnh', 'Ngủ đủ giấc']
    },

    tanshi: {
        id: 'tanshi',
        code: 'E',
        name: 'Đàm thấp chất',
        name_cn: '痰湿质',
        name_en: 'Phlegm-Dampness Constitution',
        icon: '💧',
        color: '#06B6D4',
        prevalence: '6.29%',
        characteristics: [
            'Béo phì, đặc biệt béo bụng',
            'Da dầu, nhờn',
            'Ngực bụng đầy tức',
            'Miệng dính, nhớt',
            'Đờm nhiều, cảm giác nặng nề'
        ],
        tongueFeatures: 'Lưỡi bệu, to, rêu dày nhờn trắng',
        pulseFeatures: 'Mạch hoạt (trơn)',
        diseaseTendencies: ['Béo phì', 'Tiểu đường type 2', 'Gan nhiễm mỡ', 'Đột quỵ'],
        dietaryAdvice: {
            recommended: ['Ý dĩ', 'Đậu đỏ', 'Bí đao', 'Củ cải', 'Rong biển'],
            avoid: ['Đồ ngọt', 'Đồ béo ngậy', 'Bia rượu', 'Đồ dầu mỡ']
        },
        lifestyleAdvice: ['Giảm cân', 'Tăng vận động', 'Ăn uống điều độ']
    },

    shire: {
        id: 'shire',
        code: 'F',
        name: 'Thấp nhiệt chất',
        name_cn: '湿热质',
        name_en: 'Damp-Heat Constitution',
        icon: '🌡️',
        color: '#F97316',
        prevalence: '9.88%',
        characteristics: [
            'Da dầu, bóng nhờn',
            'Hay nổi mụn, nhọt',
            'Miệng đắng, có vị lạ',
            'Phân dính, nước tiểu vàng đậm',
            'Hay có mùi cơ thể'
        ],
        tongueFeatures: 'Lưỡi đỏ, rêu vàng nhờn',
        pulseFeatures: 'Mạch hoạt sác (trơn, nhanh)',
        diseaseTendencies: ['Mụn trứng cá', 'Viêm gan', 'Gout', 'Nhiễm trùng tiết niệu'],
        dietaryAdvice: {
            recommended: ['Đậu xanh', 'Ý dĩ', 'Bí đao', 'Khổ qua', 'Trà xanh'],
            avoid: ['Rượu bia', 'Đồ cay nóng', 'Thịt cừu', 'Đồ chiên rán']
        },
        lifestyleAdvice: ['Tránh môi trường nóng ẩm', 'Giữ vệ sinh cơ thể', 'Ăn thanh đạm']
    },

    xueyu: {
        id: 'xueyu',
        code: 'G',
        name: 'Huyết ứ chất',
        name_cn: '血瘀质',
        name_en: 'Blood Stasis Constitution',
        icon: '💜',
        color: '#7C3AED',
        prevalence: '7.95%',
        characteristics: [
            'Sắc mặt tối, xỉn màu',
            'Môi tím tái',
            'Quầng thâm mắt rõ',
            'Da khô ráp, dễ có vết bầm',
            'Đau nhức cố định một chỗ'
        ],
        tongueFeatures: 'Lưỡi tím, có điểm ứ huyết, tĩnh mạch dưới lưỡi nổi',
        pulseFeatures: 'Mạch sáp, trầm (khó bắt, không đều)',
        diseaseTendencies: ['Bệnh tim mạch', 'Đột quỵ', 'U bướu', 'Đau kinh'],
        dietaryAdvice: {
            recommended: ['Nghệ', 'Gừng', 'Sơn tra', 'Hành, tỏi', 'Rượu vang đỏ (ít)'],
            avoid: ['Đồ lạnh, đá', 'Thực phẩm béo', 'Đồ ngọt nhiều']
        },
        lifestyleAdvice: ['Vận động thường xuyên', 'Massage, xoa bóp', 'Giữ ấm cơ thể']
    },

    qiyu: {
        id: 'qiyu',
        code: 'H',
        name: 'Khí uất chất',
        name_cn: '气郁质',
        name_en: 'Qi Stagnation Constitution',
        icon: '😔',
        color: '#6366F1',
        prevalence: '8.73%',
        characteristics: [
            'Hay lo âu, suy nghĩ nhiều',
            'Trầm cảm, u uất',
            'Hay thở dài',
            'Tức ngực, khó thở',
            'Cảm giác nghẹn ở cổ họng'
        ],
        tongueFeatures: 'Lưỡi hồng nhạt, rêu mỏng trắng',
        pulseFeatures: 'Mạch huyền (căng như dây đàn)',
        diseaseTendencies: ['Trầm cảm', 'Mất ngủ', 'Rối loạn tiêu hóa', 'Bệnh tuyến giáp'],
        dietaryAdvice: {
            recommended: ['Cam, quýt, bưởi', 'Trà hoa nhài', 'Hành, tỏi', 'Sơn tra'],
            avoid: ['Cà phê đậm', 'Trà đậm', 'Đồ chua chát']
        },
        lifestyleAdvice: ['Tham gia hoạt động xã hội', 'Giải tỏa stress', 'Tập thiền, yoga']
    },

    tebing: {
        id: 'tebing',
        code: 'I',
        name: 'Đặc bẩm chất',
        name_cn: '特禀质',
        name_en: 'Inherited/Allergic Constitution',
        icon: '🤧',
        color: '#EC4899',
        prevalence: '4.91%',
        characteristics: [
            'Dễ dị ứng (thực phẩm, thuốc, phấn hoa)',
            'Hắt hơi không do cảm lạnh',
            'Nghẹt mũi, chảy nước mũi theo mùa',
            'Nổi mề đay, mẩn ngứa',
            'Da nhạy cảm'
        ],
        tongueFeatures: 'Lưỡi đỏ hoặc nhạt, rêu trắng',
        pulseFeatures: 'Không có đặc điểm cố định',
        diseaseTendencies: ['Viêm mũi dị ứng', 'Hen suyễn', 'Mề đay', 'Dị ứng thuốc'],
        dietaryAdvice: {
            recommended: ['Hoàng kỳ', 'Táo đỏ', 'Mật ong địa phương', 'Ngũ cốc'],
            avoid: ['Thực phẩm gây dị ứng (tùy người)', 'Hải sản, trứng, đậu phộng']
        },
        lifestyleAdvice: ['Tránh tác nhân gây dị ứng', 'Tăng cường sức đề kháng', 'Giữ vệ sinh môi trường']
    }
};

// Classification thresholds
export const CLASSIFICATION_THRESHOLDS = {
    BALANCED_YES: 60,
    BALANCED_OTHER_MAX: 30,
    BIASED_YES: 40,
    BIASED_MAYBE: 30
};

/**
 * Get constitution by ID
 * @param {string} id - Constitution ID
 * @returns {object|null} Constitution object
 */
export function getConstitution(id) {
    return CONSTITUTION_TYPES[id] || null;
}

/**
 * Get top N constitutions by score
 * @param {object} scores - Object with constitution IDs and scores
 * @param {number} n - Number of top constitutions to return
 * @returns {array} Sorted array of constitution objects with scores
 */
export function getTopConstitutions(scores, n = 3) {
    return Object.entries(scores)
        .map(([id, score]) => ({
            ...CONSTITUTION_TYPES[id],
            score
        }))
        .filter(c => c.id) // Filter out invalid IDs
        .sort((a, b) => b.score - a.score)
        .slice(0, n);
}

/**
 * Classify constitution based on score
 * @param {number} score - Constitution score (0-100)
 * @param {string} type - 'balanced' or 'biased'
 * @returns {string} Classification: 'yes', 'maybe', or 'no'
 */
export function classifyConstitution(score, type = 'biased') {
    if (type === 'balanced') {
        return score >= CLASSIFICATION_THRESHOLDS.BALANCED_YES ? 'yes' : 'no';
    }

    if (score >= CLASSIFICATION_THRESHOLDS.BIASED_YES) return 'yes';
    if (score >= CLASSIFICATION_THRESHOLDS.BIASED_MAYBE) return 'maybe';
    return 'no';
}
